export default "__VITE_ASSET__P5k9r16i__"